import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { isMaximizer?: boolean; textColor?: string }>(
  () => ({
    root: {
      width: '100%',
      color: (props: { textColor: any }) => props.textColor,
    },
    strongTitle: {
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l32,
      display: 'block',
      color: props => props.textColor,
      [mediaQuery(1023)]: {
        textAlign: 'center',
      },
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        fontSize: FontSizes.s16,
        lineHeight: LineHeights.l28,
      },
    },
    primaryTitle: {
      display: '-webkit-box',
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s60,
      lineHeight: LineHeights.l72,
      overflow: 'hidden',

      '&.thin': {
        fontSize: FontSizes.s42,
        fontWeight: FontWeights.semibold,
        lineHeight: LineHeights.l50,
      },

      [mediaQuery(1365)]: {
        fontSize: FontSizes.s42,
        lineHeight: LineHeights.l50,
      },
      [mediaQuery(1023)]: {
        fontSize: FontSizes.s36,
        lineHeight: LineHeights.l48,
        textAlign: 'center',
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 4,
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l36,

        '&.thin': {
          fontSize: FontSizes.s24,
          lineHeight: LineHeights.l32,
        },
      },
    },
    descriptionHolder: {
      position: 'relative',
      maxHeight: 1000,
      marginTop: Spacings.s24,
      fontWeight: FontWeights.normal,
      fontSize: (props: { isMaximizer: boolean }) =>
        props.isMaximizer ? FontSizes.s20 : FontSizes.s24,
      lineHeight: LineHeights.l32,
      overflow: 'hidden',
      '-webkit-line-clamp': 5,
      '-webkit-box-orient': 'vertical',

      '&.thin': {
        marginTop: Spacings.s40,
        fontSize: FontSizes.s16,
        fontWeight: FontWeights.medium,
        lineHeight: LineHeights.l28,
      },

      [mediaQuery(1365)]: {
        fontSize: FontSizes.s20,
        marginTop: Spacings.s16,
        lineHeight: LineHeights.l24,
      },
      [mediaQuery(1023)]: {
        textAlign: 'center',
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': Spacings.s8,

        '&.thin': {
          marginTop: Spacings.s32,
          fontSize: FontSizes.s14,
          lineHeight: LineHeights.l16,
        },
      },
    },
    title: {
      fontSize: 70,
      display: '-webkit-box',
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
      fontWeight: FontWeights.bold,
      lineHeight: LineHeights.l72,
      overflow: 'hidden',

      '&.thin': {
        fontSize: FontSizes.s42,
        fontWeight: FontWeights.semibold,
        lineHeight: LineHeights.l50,
      },

      [mediaQuery(1365)]: {
        fontSize: FontSizes.s42,
        lineHeight: LineHeights.l50,
      },
      [mediaQuery(1023)]: {
        fontSize: FontSizes.s36,
        lineHeight: LineHeights.l48,
        textAlign: 'center',
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 4,
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l36,

        '&.thin': {
          fontSize: FontSizes.s24,
          lineHeight: LineHeights.l32,
        },
      },
    },
  }),
  {
    name: 'wallpaper-banner-content',
  },
);

export default useStyles;
